module.exports = __webpack_public_path__ + "img/US_ResourceGold_ua.a140799f.webp";